import React, { Component } from 'react';
import { RelatedEntityGrid as EntityGrid, ModelJson, ModelTextInput, ModelDropDown, ModelCalendar, ModelInputNumber } from 'hay-core-react';
import PublicacaoLog from '../../../models/PublicacaoLog';
import PublicacaoLogStatusEnum from '../../../enums/PublicacaoLogStatusEnum';

const model = {
    id: { exibir: 'main.id', visivel: true, fixar: true, largura: '18rem' },
    updatedAt: { visivel: false },
    createdAt: { visivel: false },
    publicacao: { exibir: 'main.publicacaolog.publicacao' },
    iniciorequisicao: { exibir: 'main.publicacaolog.iniciorequisicao', visivel: true, tipo: 'date', time: true, fixar: true, largura: '12rem' },
    verbo: { exibir: 'main.publicacaolog.verbo', visivel: true, fixar: true, largura: '6rem' },
    endpoint: { exibir: 'main.publicacaolog.endpoint', visivel: true },
    statuscode: { exibir: 'main.publicacaolog.statuscode', visivel: true, tipo: 'numeric', largura: '6rem' },
    status: { exibir: 'main.publicacaolog.status', visivel: true, tipo: 'enum', entidade: 'publicacaolog.status', largura: '7rem' },
    duracaoms: { exibir: 'main.publicacaolog.duracaoms', visivel: true, tipo: 'numeric', largura: '7rem' },
    fimrequisicao: { exibir: 'main.publicacaolog.fimrequisicao', tipo: 'date', time: true },
    query: { exibir: 'main.publicacaolog.query' },
    body: { exibir: 'main.publicacaolog.body' },
    resposta: { exibir: 'main.publicacaolog.resposta' },
    tamanhobytessolicitacao: { exibir: 'main.publicacaolog.tamanhobytessolicitacao', tipo: 'numeric' },
    tamanhobytesresposta: { exibir: 'main.publicacaolog.tamanhobytesresposta', tipo: 'numeric' },
};

const renderers = { 'publicacaolog.status': PublicacaoLogStatusEnum };

class PublicacaoLogFormulario extends Component {
    render() {
        const { model: m, contexto } = this.props;
        return <div className="grid">
            <div className="field col-12 md:col-6"><ModelTextInput model={{ ...m.endpoint, disabled: true }} contexto={contexto} /></div>
            <div className="field col-6 md:col-2"><ModelTextInput model={{ ...m.verbo, disabled: true }} contexto={contexto} /></div>
            <div className="field col-6 md:col-2"><ModelInputNumber model={{ ...m.statuscode, disabled: true }} contexto={contexto} /></div>
            <div className="field col-12 md:col-2"><ModelDropDown model={{ ...m.status, disabled: true }} contexto={contexto} /></div>
            <div className="field col-12 md:col-4"><ModelCalendar model={{ ...m.iniciorequisicao, disabled: true }} contexto={contexto} /></div>
            <div className="field col-12 md:col-4"><ModelCalendar model={{ ...m.fimrequisicao, disabled: true }} contexto={contexto} /></div>
            <div className="field col-12 md:col-4"><ModelInputNumber model={{ ...m.duracaoms, disabled: true }} contexto={contexto} /></div>
            <div className="field col-12 md:col-4"><ModelJson model={m.query} contexto={contexto} /></div>
            <div className="field col-12 md:col-4"><ModelJson model={m.body} contexto={contexto} /></div>
            <div className="field col-12 md:col-4"><ModelJson model={m.resposta} contexto={contexto} /></div>
        </div>;
    }
}

export default class PublicacaoLogTemplate extends Component {
    render() {
        return <EntityGrid
            entidade={PublicacaoLog}
            model={model}
            identidade="main.publicacaolog"
            permissoes={this.props.permissoes}
            icone="pi-list"
            storageKey="dt-publicacaologs"
            relacionados={[]}
            renderers={renderers}
            configuracao={this.props.configuracao}
            ordenacaoPadrao={{ sortField: 'iniciorequisicao', sortOrder: -1 }}
            formulario={(m, ctx) => <PublicacaoLogFormulario model={m} contexto={ctx} />}
        />;
    }
}
